<template>
  <div class="instant-payment-wrapper" :style="cssVars()">
    <!-- 标题 -->
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px; background-color: #f9f9fb;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" @click-left="handleBack" />
          <span class="tit-left">{{ $t('lang.Withdrawal.k011') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <!-- 内容 -->
    <div class="main">
      <div class="title">{{ $t('lang.Withdrawal.k008') }}</div>
      <div class="title">{{ $t('lang.Withdrawal.k009') }}</div>
      <div class="subtitle">{{ $t('lang.Withdrawal.k010') }}</div>
      <!-- 状态 -->
      <div v-for="item in conditionsList" :key="item.condition" class="status-item">
        <div class="left">
          <span v-if="item.checkResult" class="icon success-icon"></span>
          <img v-else src="@/assets/packageAssets/views/P1_Girls/Withdrawal/default/fail.webp" alt="icon" class="icon" width="18" height="18" />
          <span class="text">{{ item.condition }}</span>
        </div>
        <div class="right">{{ item.performance }}</div>
      </div>
      <!-- 支持的提款方式 -->
      <div class="support">{{ $t('lang.Withdrawal.k007') }}</div>
      <template v-if="isSupport">
        <div class="no-support">{{ $t('lang.Withdrawal.k006') }}</div>
      </template>
      <template v-else>
        <div v-for="item in channelsList" :key="item.name" class="organization">
          <img :src="item.icon | imgPath" alt="icon" height="18" class="icon" />
          <span>{{ item.name }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { apiWithdrawAutoCheckResult } from '@/api/imee'
import { pageCssVars } from './z-style-cfg.js'

export default {
  mixins: [pageCssVars],
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      isSupport: false,
      conditionsList: [],
      channelsList: [],
    }
  },
  mounted() {
    this.handleGetStatus()
  },
  methods: {
    handleBack() {
      this.goPrevious()
    },
    async handleGetStatus() {
      try {
        const res = await apiWithdrawAutoCheckResult()
        this.conditionsList = (res || {}).conditions || []
        this.channelsList = (res || {}).instantPayChannels || []
        if (this.channelsList.length === 0) {
          this.isSupport = true
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.instant-payment-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: var(--lh-body-24);
    .title {
      width: 100%;
      height: fit-content;
      padding-bottom: 32px;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      color: #333333;
      line-height: var(--lh-body-24);
      font-style: normal;
    }
    .subtitle {
      width: 100%;
      height: fit-content;
      padding-bottom: 16px;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-700);
      color: #333333;
      line-height: var(--lh-body-24);
      font-style: normal;
    }
    .status-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: fit-content;
      padding-bottom: 24px;
      .left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: fit-content;
        .icon {
          margin-right: 4px;
        }
        .success-icon {
          display: inline-block;
          width: 18px;
          height: 18px;
          background: var(--ip-success-icon) center / contain no-repeat;
        }
        .text {
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          color: #333333;
          font-style: normal;
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        color: #333333;
        font-style: normal;
      }
    }
    .support {
      width: 100%;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-700);
      color: #333333;
      margin-top: 10px;
      margin-bottom: 16px;
    }
    .no-support {
      width: 100%;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      color: #999999;
    }
    .organization {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      margin-bottom: 24px;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      color: #333333;
      font-style: normal;
      .icon {
        margin-right: 4px;
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .instant-payment-wrapper {
    .main {
      .status-item {
        .left {
          .icon {
            margin-right: 0;
            margin-left: 4px;
          }
        }
      }
      .organization {
        .icon {
          margin-right: 0;
          margin-left: 4px;
        }
      }
    }
  }
}
</style>
